<template>
  	<div>
		<breadcrumb :items="breadcrumbs"></breadcrumb>
    		<v-container fluid>
      			<v-form 
      				v-on:submit.prevent="updateFarm"
      				ref="form"
        			v-model="valid"
        			lazy-validation
				>
        			<div class="page-title">
          				<div class="text-h5 font-weight-black">{{$t('farm.farmRegistration')}}</div>
          				<v-spacer></v-spacer>
          				<template>
            				<div class="mt-5 text-center data-drop">
								<v-menu
									bottom
									origin="center center"
									transition="scale-transition"
								>
                					<template v-slot:activator="{ on, attrs }">
                  						<v-btn
											@click="$router.push({ name: 'My farm' })"
											v-bind="attrs"
											v-on="on"
											outlined
											color="primary"
											dark
											depressed
										>
                   						{{$t('farm.cancel')}}
                  						</v-btn>
										<v-btn
											color="primary"
											dark
											v-bind="attrs"
											v-on="on"
											type="submit"
											depressed
										>
										{{$t('update')}}
										</v-btn>
                					</template>
              					</v-menu>
            				</div>
          				</template>
        			</div>
        			<div class="mt-2 form-section">
        				<v-card class="mb-2" flat>
          					<v-container fluid>
          						<div class="font-weight-bold">{{$t('farm.farmInformation')}}</div>
          						<template>
									<v-row class="mt-2">
										<v-col cols="12" sm="6" md="3">
											<label for="text"> {{$t('farm.farmName')}}<span>*</span></label>
											<v-text-field
											v-model="farm.farmName"
											:placeholder="$t('farm.farmName')"
											outlined
											dense
											required
											:error-messages="errors.name"
											:rules="farmRules.farmName"
											></v-text-field>
										</v-col>

                						<v-col cols="12" sm="6" md="3">
                  							<label for="text">{{$t('farm.farmType')}}<span>*</span></label>
											<v-select
												v-model="farm.farmType"
												:items="farmTypes"
												item-text="name"
												item-value="id"
												:placeholder="$t('farm.farmType')"
												outlined
												dense
												class="text-capitalize"
												:error-messages="errors.farmType"
												:rules="farmRules.farmType"
											></v-select>
                						</v-col>

										<v-col cols="12" sm="6" md="3">
											<label for="text">{{$t('farm.farmOwner')}} <span>*</span></label>
											<v-autocomplete
												v-model="farm.farmOwner"
												:items="farmers"
												outlined
												dense
												class="text-capitalize"
												item-text="fullName"
												item-value="id"
												:placeholder="$t('farm.farmOwner')"
												:error-messages="errors.ownerId"
												:rules="farmRules.ownerId"
											></v-autocomplete>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label for="text">{{$t('farm.ownershipType')}} <span>*</span></label>
											<v-select
											:items="ownershipTypes"
											item-text="name"
											item-value="id"
											:placeholder="$t('farm.ownershipType')"
											outlined
											dense
											v-model="farm.farmOwnershipType"
											class="text-capitalize"
											:error-messages="errors.farmownershipType"
											:rules="farmRules.farmOwnershipType"
											></v-select>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.govRegistrationNo')}}</label>
											<v-text-field
												:placeholder="$t('farm.govRegistrationNo')"
												outlined
												dense
												v-model="farm.govRegistrationNum"
							
										
											></v-text-field>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.contractMating')}}<span>*</span></label>
											<v-text-field
												:placeholder="$t('farm.contractMating')"
												outlined
												dense
												v-model="farm.contractMating"
												:error-messages="errors.contractMating"
												:rules="farmRules.contractMating"
											></v-text-field>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.productionSystem')}} 
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>Types of farming system should be chosen depending upon the geographical and local
													climatic conditions with keeping economics in mind. E.g. Loose Farming, Conventional barn
													system and free range system.</span>
											</v-tooltip>
										</label>
											<v-select
												:items="farmProductionSystems"
												:placeholder="$t('farm.productionSystem')"
												outlined
												dense
												class="text-capitalize"
												item-text="name"
												item-value="id"
												v-model="farm.productionSystem"
												multiple
											></v-select>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.cooperativeId')}} </label>
											<v-text-field
												:placeholder="$t('farm.cooperativeId')"
												outlined
												dense
												v-model="farm.cooperativeId"
					
											></v-text-field>
										</v-col>
              						</v-row>
          						</template>
          					</v-container>
          				</v-card>
          				<v-card class="mt-5 mb-5" flat>
            				<v-container fluid>
								<div class="font-weight-bold">{{$t('farm.farmLicenseInformation')}}</div>
          						<template>
              					<v-row class="mt-2">
									<v-col cols="12" sm="6" md="3">
										<label>{{$t('farm.licenseNumber')}} </label>
										<v-text-field
											:placeholder="$t('farm.licenseNumber')"
											outlined
											v-model="farm.licenceNum"
											dense
									
										></v-text-field>
									</v-col>

                					<v-col cols="12" sm="6" md="3">
                  						<label>{{$t('farm.licenseExpiryDate')}} </label>
										<v-menu
											ref="menu"
											v-model="menu"
											:close-on-content-click="false"
											dense
											transition="scale-transition"
											offset-y
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="farm.licenceExpiryDate"
												placeholder="Choose the date"
												append-icon="mdi-calendar"
												outlined
												readonly
												dense
												v-bind="attrs"
												v-on="on"
												v-on:click:append="menu=true"
												:error-messages="errors.licenceED"
												:rules="farmRules.licenceED"
											></v-text-field>
											</template>
                    						<v-date-picker v-model="farm.licenceExpiryDate" no-title scrollabel :min="new Date().toISOString().substr(0, 10)">
                      						<v-spacer></v-spacer>
											<v-btn text color="primary" @click="menu = false">
												{{$t('farm.cancel')}}
											</v-btn>
											<v-btn
												text
												color="primary"
												@click="$refs.menu.save(farm.licenceExpiryDate)"
											>
												{{$t('farm.ok')}}
											</v-btn>
                   		 				</v-date-picker>
                  					</v-menu>
                				</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.regulatorName')}} </label>
									<v-text-field
									:placeholder="$t('farm.regulatorName')"
									outlined
									dense
									v-model="farm.regulatorName"
					
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" md="3">
									<label>{{$t('farm.regulatorRepresentativeName')}} </label>
									<v-text-field
										:placeholder="$t('farm.regulatorRepresentativeName')"
										outlined
										dense
										v-model="farm.regulatorRepresentiveName"
							
									></v-text-field>
								</v-col>
              				</v-row>
          				</template>
          			</v-container>
				</v-card>
          		<v-card class="mt-5" flat>
            		<v-container fluid class="pb-10">
						<div class="font-weight-bold">{{$t('farm.farmLocationSize')}}</div>
          					<template>
              					<v-row class="mt-2">
                					<v-col cols="12" sm="6" md="3">
                    					<label>{{$t('farm.country')}} <span>*</span></label>
											<v-autocomplete
                                           	 	outlined
                                            	:items="countries"
                                            	item-value="Name"
                                            	class="phone-drop rounded-r-0 outline-l-0"
                                            	v-model="farm.country"
                                            	:filter="filterCountry"
                                            	dense
                                            	ref="phoneSelect"
                                            	:rules="farmRules.country"
                                        >
                                            <template v-slot:item="slotProps">
                                                <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                                {{`${slotProps.item.Name}` }}
                                            </template>
                                            <template slot="selection" slot-scope="data">
                                                <span class="text-truncate">{{`${data.item.Name }` }}</span>
                                            </template>
                                        </v-autocomplete>
                						</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('Province/State')}}<span>*</span></label>
											<v-text-field
												:placeholder="$t('Province/State') "
												outlined
												dense
												v-model="farm.state"
												:rules="farmRules.houseNo"
											></v-text-field>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.city')}} <span>*</span></label>
											<v-text-field
												:placeholder="$t('farm.state') "
												outlined
												dense
												v-model="farm.city"
												:rules="farmRules.city"
											></v-text-field>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.street')}} </label>
											<v-text-field
												:placeholder="$t('farm.street')"
												outlined
												dense
												v-model="farm.street"
												:rules="farmRules.street"
											></v-text-field>
										</v-col>

										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.houseNumber')}}</label>
											<v-text-field
												:placeholder="$t('farm.houseNumber') "
												outlined
												dense
												v-model="farm.houseNum"
										
											></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.totalFarmSize')}} <span>*</span></label>
											<v-row no-gutters class="d-flex">
												<v-col cols="6" class="pr-1">
												<v-text-field
													:placeholder="$t('farm.totalFarmSize')"
													v-model="farm.area"
													outlined
													dense
													:rules="farmRules.farmSize"
												></v-text-field>
												</v-col>
												<v-col cols="6">
												<v-select
													:items="farmUni"
													placeholder="Select Unit"
													outlined
													class="text-capitalize"
													item-text="name"
													item-value="id"
													dense
													v-model="farm.areaUomId"
												></v-select>
												</v-col>
											</v-row>
										</v-col>
              						</v-row>
							</template>
							<v-row class="px-5">
									
								<v-btn
									color="primary"
									dark
									depressed
									outlined
									@click="showMap=true"
								>
									{{$t('USE GEOFENCE TOOL')}}
								</v-btn>

									<v-btn
									color="darkGray"
									dark
									depressed
									outlined
								>
									{{$t('Add Zones to this farm')}}
								</v-btn>
									{{ farm.lng }}
							</v-row>
						</v-container>
					</v-card>
				</div>
				
			</v-form>
		</v-container>
		<current-location v-if="showMap" :farm="orgFarm" :showMap="showMap" @close-location-modal="locationMapClosed"></current-location>
	</div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import FarmService from "@/_services/farmService";
import Breadcrumb from "@/components/core/Breadcrumb";
import { farmRules } from "@/validations/FarmFormRules.js";
import countries from "@/constants/countries.js"
import generalMixin from "@/mixins/GeneralMixin";

import CurrentLocation from "@/views/geofence/current-location.vue";

export default {
	async mounted() {
        this.startLoading()
        this.orgFarm = await FarmService.getfarm(this.$route.params.id);
        await this.assignValues(this.orgFarm);
		this.farmers = await FarmService.getFarmers();
		const options = await FarmService.getFarmOptions();
		this.farmTypes = options.FarmTypes;
		// this.ownershipTypes = options['farm-ownership-type'];
		this.farmProductionSystems = options.FarmProductionSystem;
        this.stopLoading();
	},
  	components: {
        'breadcrumb': Breadcrumb,
		CurrentLocation
    },
  	data() {
    	return {
			orgFarm: null,
			countries,
			farmers: [],
			farmProductionSystems: [],
			farmTypes: [],
			ownershipTypes: [
				{ id: 'personal', name: 'Personal'},
				{ id: 'community', name: 'Community'},
				{ id: 'corporate', name: 'Corporate'}
			],
			showMap: false,
			menu: "",
			error: false,
			countryLoading:false,
			stateLoading:false,
			cityLoading:false,
			errors: {
				name: "",
				farmType: "",
				farmownershipType: "",
				ownerName: "",
				govRegistrationNo: "",
				contractMating: "",
				productionSystemOptId: "",
				regulatorRepName: "",
				cooperativeID: "",
				licenceNumber: "",
				licenceED: "",
				regulatorName: "",
				lat:"",
				log:""
			},
			breadcrumbs: [
				{
					text: this.$t('dashboard'),
					disabled: false,
					to:"/"
				},
				{
					text: this.$t('farm.farms'),
					link: true,
					exact: true,
					disabled: false,
					to:{name:"My farm"}
				},
				{
					text: this.$t('farm.registerAfarm'),
					disabled: true,
				},
			],
			farm: {
                id: null,
				farmName: "",
				registrationNo: "",
				lat: 0,
				log: 0,
				address: "Test address", 
				area: 0,
				areaUomId: null,
				parameter: 0,
				parameterUomId: 0,
				farmingGoals: [],
				farmOwnershipType: "",
				farmGeofence: [],
				farmType: null,
				productionSystem: null,
				farmOwner: null,
				country: "India",
				state: "",
				city: "",
				govRegistrationNum: "",
				contractMating: "",
				cooperativeId: "",
				licenceNum: "",
				licenceExpiryDate: '',
				regulatorName: "",
				houseNum: "",
				street: "",
				regulatorRepresentiveName: ""
			},
			// countryId: 101,
			// stateId: 4022,
			// farmType: [],
			// farmownershipType: [],
			// productionSystem: [],
			// res: [],
			farmUni: [{ id: 1, name: "hectare" }],
			periUni: [{ id: 2, name: "hectare" }],
			farmRules,
			valid: true,
			// country: [],
			// state: [],
			// city: [],
			// users:[],
    	};
  	},

  methods: {
    async assignValues(farm) {
        // console.log('edited', farm)
        this.farm.id= farm.id,
        this.farm.farmName= farm.farmName,
        this.farm.registrationNo= null,
        this.farm.lat= farm.lat,
        this.farm.log= farm.log,
        this.farm.address= farm.address, 
        this.farm.area= farm.area,
        this.farm.areaUomId= farm.areaUomId,
        this.farm.parameter= farm.parameter,
        this.farm.parameterUomId= 0,
        this.farm.farmingGoals= [],
        this.farm.farmOwnershipType= farm.farmOwnershipType,
        this.farm.farmGeofence= [],
        this.farm.farmType= farm.farmType,
        this.farm.productionSystem= farm.productionSystem,
        this.farm.farmOwner= farm.farmOwner,
        this.farm.country= farm.country,
        this.farm.state= farm.state,
        this.farm.city= farm.city,
        this.farm.govRegistrationNum= farm.govRegistrationNum,
        this.farm.contractMating= farm.contractMating,
        this.farm.cooperativeId= farm.cooperativeId,
        this.farm.licenceNum= farm.licenceNum,
        this.farm.licenceExpiryDate= this.formatDate(farm.licenceExpiryDate),
        this.farm.regulatorName= farm.regulatorName,
        this.farm.houseNum= farm.houseNum,
        this.farm.street= farm.street,
        this.farm.regulatorRepresentiveName= farm.regulatorRepresentiveName
        return Promise.resolve(true)
    },

	locationMapClosed(data) {
		this.showMap = false;
		this.farm.lat = data.lat;
		this.farm.log = data.lng
	},
    loadOptions() {
      const options = {
        options: ["production-system", "farm-ownership-type", "farm-type"],
      };
      FarmService.loadoptions(options).then((data) => {
        let newdata = data.data["production-system"];
        this.productionSystem = newdata;
        let ownerdata = data.data["farm-ownership-type"];
        this.farmownershipType = ownerdata.map((item) => item.name);
        let farmdata = data.data["farm-type"];
        this.farmType = farmdata.map((item) => item.name);
      });
    },
    updateFarm() {
        console.log(1111)
       if (!this.$refs.form.validate()) return;
      	this.startLoading();
      	FarmService.editfarm(this.farm)
        .then((data) => {
          console.log(data);
          	if (data.success == true) {
				this.$router.push({ name: 'SingleFarm', params: {id: this.$route.params.id}});
            	this.$notify({
					title: "Farm updated",
					text: data.message,
					type: "success",
				});
			} else {
				this.$notify({
					title: "Farm Not Updated",
					text: data.message,
					type: "error",
				});
          	}
          	this.stopLoading()
        })
        .catch((err) => {
          	console.log(err);
          	this.stopLoading()
        }).finally(() => {
          	this.farm = {};
          	this.$refs.form.reset()
        });
    },
  },
  mixins: [loadingMixin, generalMixin],
};
</script>

<style >
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
.button {
  float: right;
}
.v-btn {
  margin-right: 5px;
}
.route {
  text-decoration: none !important;
}
.form-group {
  margin-top: -20px;
}
.form-section label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.form-section label span{
  color: red;
}
.v-list-item__title{
  text-transform: capitalize;
}

/* .v-col.label{
  font-weight: bold;
} */
</style>